import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubscribeStatus('success');
    setEmail('');
    setTimeout(() => setSubscribeStatus('idle'), 3000);
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/30">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-18">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5 cursor-pointer group">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-eye-2-fill text-background-50 text-xl"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-base font-bold text-foreground-900 font-heading tracking-wide">
                  51暗网
                </span>
                <span className="text-[10px] text-foreground-400 font-label tracking-widest uppercase">
                  CHIGUA
                </span>
              </div>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-sm">
              聚焦网红主播塌房黑料，每日大瓜实时追踪。51暗网吃瓜官网入口，汇集最新吃瓜爆料内容，做最有料的吃瓜平台。
            </p>

            <form onSubmit={handleSubscribe} className="flex gap-2 max-w-sm">
              <div className="flex-1 relative">
                <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅每日大瓜"
                  required
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg bg-background-200/50 border border-background-300/30 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors"
                />
              </div>
              <button
                type="submit"
                className="whitespace-nowrap px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer"
              >
                订阅
              </button>
            </form>
            {subscribeStatus === 'success' && (
              <p className="text-xs text-secondary-400 mt-2">订阅成功！每日大瓜将准时送达。</p>
            )}

            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-fill text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 hover:bg-primary-500/20 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-fill text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-label tracking-wide uppercase">
              吃瓜分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-label tracking-wide uppercase">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/meiri-dagua" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  每日大瓜
                </Link>
              </li>
              <li>
                <Link to="/category/wanghong-tafang" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  网红塌房
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-label tracking-wide uppercase">
              联系方式
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-xs"></i>
                <span>hello@blw91.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-phone-line text-xs"></i>
                <span>400-888-5151</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-map-pin-line text-xs"></i>
                <span>北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 51暗网 Chigua. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}